export default __webpack_public_path__ + "static/media/AMZN_AT_SH_SD.2b56c0ff.svg";